import React from "react";
import {
  intro_steps_1,
  intro_steps_2,
  intro_steps_3,
} from "./constants/autojamData";
import styles from "./AutoJam.module.scss";
import { type Stage } from "../../types";
import autojam_1 from "./assets/autojam_1.png";
import autojam_2 from "./assets/autojam_2.png";
import { StageSection } from "@/modules/ServiceCore/components/StageSection";
import { StepRenderer } from "@/modules/ServiceCore/components/StepRenderer";
import { useUiStore } from "@/shared/stores/uiStore";
import { useServiceWorkflowStore } from "@/shared/stores/serviceWorkflowStore";
import { Card } from "@/shared/ui";

interface IntroProps {
  setStage: (stage: Stage) => void;
}

export const IntroSection: React.FC<IntroProps> = ({ setStage }) => {
  const { openModal } = useUiStore();
  const { onTokenAddedCallback, pId } = useServiceWorkflowStore();

  return (
    <Card variant="narrow">
      <div className={styles.introContent}>
        <h2 className={styles.sectionMainTitle}>Автоджем — анализ кластеров</h2>
        <div className={styles.sectionText}>
          Экономьте время и получайте чистые, готовые к анализу данные по
          кластерам в одном месте
        </div>
        <div className={styles.sectionImage}>
          <img src={autojam_1} alt="" loading="lazy" />
        </div>

        <StageSection
          title="5 минут и таблица уже работает!"
          steps={intro_steps_1}
          StepRenderer={StepRenderer}
        />
        <div className={styles.sectionImage}>
          <img src={autojam_2} alt="" loading="lazy" />
        </div>
        <StageSection
          title="Какие показатели?"
          steps={intro_steps_2}
          StepRenderer={StepRenderer}
        />
        <div className={styles.separatedBlock}>
          <StageSection
            title="Преимущества"
            steps={intro_steps_3}
            StepRenderer={StepRenderer}
            useDots={true}
          />
          <div className={styles.sectionText}>
            Превратите хаос данных в четкие решения.
          </div>
        </div>

        <div className={styles.buttonsWrap}>
          {pId ? (
            <button
              className={styles.primaryButton}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                setStage("select_table");
              }}
            >
              Подключить
            </button>
          ) : (
            <button
              className={styles.primaryButton}
              onClick={() =>
                openModal("TOKEN", { onTokenAdded: onTokenAddedCallback })
              }
            >
              Добавить токен
            </button>
          )}
          <button
            className={styles.secondaryButton}
            onClick={(e) => {
              e.preventDefault();
              window.open("https://t.me/selleralarm_support_bot", "_blank");
            }}
          >
            Поддержка
          </button>
        </div>
      </div>
    </Card>
  );
};
